import { Component, OnInit, Input, OnDestroy, HostListener, ElementRef, Renderer, ViewChild } from '@angular/core';

@Component({
  selector: 'ant-avatar',
  template:`<span [ngClass]="{'ant-avatar-sm': size == 'small','ant-avatar-lg':size == 'large','ant-avatar-square':shape == 'square','ant-avatar-circle':shape=='circle','ant-avatar-icon':_icon,'ant-avatar-classtype':_classtype}" class="ant-avatar" #classType>
    <i *ngIf="_icon" [class]="'anticon '+ _icon"></i>
    <img *ngIf='iconImage' #linkRel/>
<ng-content></ng-content>
</span>`,
  styles: [`.ant-avatar {
  display: inline-block;
  text-align: center;
  background: #ccc;
  color: #fff;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 16px;
}
.ant-avatar > * {
  line-height: 32px;
}
.ant-avatar.ant-avatar-icon {
  font-size: 18px;
}
.ant-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
}
.ant-avatar-lg > * {
  line-height: 40px;
}
.ant-avatar-lg.ant-avatar-icon {
  font-size: 24px;
}
.ant-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 12px;
}
.ant-avatar-sm > * {
  line-height: 24px;
}
.ant-avatar-sm.ant-avatar-icon {
  font-size: 14px;
}
.ant-avatar-square {
  border-radius: 4px;
}
.ant-avatar > img {
  width: 100%;
  height: 100%;
  display: block;
}
`]
})
export class AvatarComponent implements OnInit {

  public _element: ElementRef;
  public _classtype = false;
  public _icon: string | boolean;
  public _iconimage = false;

  @Input() public shape = 'circle';
  // 形状：circle | square
  @Input() public size = '';
  // 大小 ：large | small | default
  @Input() public src = '';
  @Input() public classType: Object;
  @Input() public linkRel: Object;
  @Input() public set icon(value) {
    if (!value) {
      this._icon = false
      return;
    }
    this._icon = 'anticon-' + value
  };
  @Input() public iconImage;


  constructor(public renderer: Renderer) {

  }
  @ViewChild('classType') classTypeEl: ElementRef;
  @ViewChild('linkRel') linkRelEl: ElementRef;

  ngOnInit() {

  }
  // 渲染组件调用
  ngAfterViewInit() {
    console.log(this)
    // 遍历新增class样式
    for (let i in this.classType) {
      this.setEleCss(this.classTypeEl, i, this.classType[i]);
    }
    if (this.iconImage) {
      this.renderer.setElementAttribute(this.linkRelEl.nativeElement, 'src', this.iconImage.src)
    }
  }
  public setEleCss(el: ElementRef, key: string, value: string) {
    this.renderer.setElementStyle(el.nativeElement, key, value)
  }
}
